import React from 'react';
import { useNavigate } from 'react-router-dom';
import { blogPosts } from './BlogPost';

// ADD THIS:
interface Post {
    id: string;
    title: string;
    date: string;
    author: string;
    category: string;
    excerpt: string;
    content: string;
    image?: string;
  }

const BlogList: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div style={{
      fontFamily: "'Inter', sans-serif",
      background: '#f5f5f5',
      minHeight: '100vh'
    }}>
      {/* Hero */}
      <div style={{
        background: 'linear-gradient(135deg, #6C5CE7, #5B4BC4)',
        color: 'white',
        padding: '80px 40px',
        textAlign: 'center'
      }}>
        <h1 style={{
          fontSize: '3rem',
          fontWeight: '800',
          marginBottom: '15px'
        }}>
          PlotBuzz Blog
        </h1>
        <p style={{
          fontSize: '1.2rem',
          opacity: 0.9
        }}>
          Tips, insights, and resources for teaching creative writing
        </p>
      </div>

      {/* Posts Grid */}
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '60px 40px'
      }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
          gap: '30px'
        }}>
          {blogPosts.map((post: Post) => (
            <article
              key={post.id}
              onClick={() => navigate(`/blog/${post.id}`)}
              style={{
                background: 'white',
                borderRadius: '12px',
                overflow: 'hidden',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                cursor: 'pointer',
                transition: 'transform 0.2s, box-shadow 0.2s'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
              }}
            >
              <div style={{ padding: '30px' }}>
                <div style={{
                  background: '#F3F0FF',
                  color: '#6C5CE7',
                  display: 'inline-block',
                  padding: '6px 12px',
                  borderRadius: '6px',
                  fontSize: '0.8rem',
                  fontWeight: '600',
                  marginBottom: '15px'
                }}>
                  {post.category}
                </div>

                <h2 style={{
                  fontSize: '1.4rem',
                  fontWeight: '700',
                  color: '#333',
                  marginBottom: '12px',
                  lineHeight: '1.3'
                }}>
                  {post.title}
                </h2>

                <p style={{
                  fontSize: '1rem',
                  color: '#666',
                  lineHeight: '1.6',
                  marginBottom: '20px'
                }}>
                  {post.excerpt}
                </p>

                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  fontSize: '0.85rem',
                  color: '#999',
                  paddingTop: '15px',
                  borderTop: '1px solid #e0e0e0'
                }}>
                  <span>{post.date}</span>
                  <span style={{ color: '#6C5CE7', fontWeight: '600' }}>
                    Read more →
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BlogList;